import { UPPER_AND_LOWER_HA } from '../../../constants/seo/jobTrendConstants';
import { KODAWARI } from '../../../constants/seo/kodawari';

/**
 * 各カテゴリごとの棒グラフでの初期表示（件数が多いorIDが若い）を取得する処理
 * @param rankingList 各カテゴリごとの棒グラフ用のdataとdatalabelが入った配列
 * @returns 各カテゴリごとの初期表示されているidと項目名と求人数
 */
export const createInitialValueForBargraph = (rankingList) => {
  const require = KODAWARI.requirements.find(
    (op) => op.text === rankingList.requirements[1][0]
  );

  const initialRequire = {
    value: require?.value,
    text: require?.text,
    count: Number(rankingList.requirements[0][0]),
  };

  let incomeHa;
  let countHa;
  if (rankingList.income[0][0] !== 0) {
    incomeHa = UPPER_AND_LOWER_HA.find(
      (ha) => ha.name === rankingList.income[1][0]
    );
    const [[count]] = rankingList.income;
    countHa = count;
  } else {
    for (let i = 0; i < rankingList.income[0].length; i += 1) {
      if (rankingList.income[0][i] > 0) {
        incomeHa = UPPER_AND_LOWER_HA.find(
          (ha) => ha.name === rankingList.income[1][i]
        );
        countHa = rankingList.income[0][i];
        break;
      }
    }
    if (!incomeHa) {
      incomeHa = UPPER_AND_LOWER_HA.find(
        (ha) => ha.name === rankingList.income[1][0]
      );
      const [[count]] = rankingList.income;
      countHa = count;
    }
  }
  const initialIncome = {
    id: incomeHa?.id,
    lowerId: incomeHa?.lowerId,
    upperId: incomeHa?.upperId,
    name: incomeHa?.name,
    count: countHa,
  };

  const workplace = KODAWARI.workplaceEnvironment.find(
    (op) => op.text === rankingList.workplaceEnvironment[1][0]
  );
  const initialWorkplace = {
    value: workplace?.value,
    text: workplace?.text,
    count: Number(rankingList.workplaceEnvironment[0][0]),
  };

  const holiday = KODAWARI.holidayAndWayOfWorking.find(
    (op) => op.text === rankingList.holidayAndWayOfWorking[1][0]
  );
  const initialHoliday = {
    value: holiday?.value,
    text: holiday?.text,
    count: Number(rankingList.holidayAndWayOfWorking[0][0]),
  };

  let averageAge;
  let countAvg;
  if (rankingList.employeeAverageAge[0][0] !== 0) {
    averageAge = KODAWARI.employeeAverageAge.find(
      (op) => op.text === rankingList.employeeAverageAge[1][0]
    );
    const [[count]] = rankingList.employeeAverageAge;
    countAvg = count;
  } else {
    for (let i = 0; i < rankingList.employeeAverageAge[0].length; i += 1) {
      if (rankingList.employeeAverageAge[0][i] > 0) {
        averageAge = KODAWARI.employeeAverageAge.find(
          (op) => op.text === rankingList.employeeAverageAge[1][i]
        );
        countAvg = rankingList.employeeAverageAge[0][i];
        break;
      }
    }
    if (!averageAge) {
      averageAge = KODAWARI.employeeAverageAge.find(
        (op) => op.text === rankingList.employeeAverageAge[1][0]
      );
      const [[count]] = rankingList.employeeAverageAge;
      countAvg = count;
    }
  }
  const initialEmployeeAverageAge = {
    value: averageAge?.value,
    text: averageAge?.text,
    count: countAvg,
  };

  const status = KODAWARI.employmentStatus.find(
    (op) => op.text === rankingList.employmentStatus[1][0]
  );
  const initialEmploymentStatus = {
    value: status?.value,
    text: status?.text,
    count: Number(rankingList.employmentStatus[0][0]),
  };

  const benefit = KODAWARI.welfareBenefits.find(
    (op) => op.text === rankingList.welfareBenefits[1][0]
  );

  const initialWelfareBenefit = {
    value: benefit?.value,
    text: benefit?.text,
    count: Number(rankingList.welfareBenefits[0][0]),
  };

  const positions = KODAWARI.positions.find(
    (op) => op.text === rankingList.positionsAndLanguageSkills[1][0]
  )
    ? KODAWARI.positions.find(
        (op) => op.text === rankingList.positionsAndLanguageSkills[1][0]
      )
    : undefined;
  const initialPositions = {
    value: positions?.value,
    text: positions?.text,
    count: Number(rankingList.positionsAndLanguageSkills[0][0]),
  };

  const language = KODAWARI.languageSkills.find(
    (op) => op.text === rankingList.positionsAndLanguageSkills[1][0]
  )
    ? KODAWARI.languageSkills.find(
        (op) => op.text === rankingList.positionsAndLanguageSkills[1][0]
      )
    : undefined;
  const initialLanguage = {
    value: language?.value,
    text: language?.text,
    count: Number(rankingList.positionsAndLanguageSkills[0][0]),
  };

  let es;
  let countEs;
  if (rankingList.establish[0][0] !== 0) {
    es = KODAWARI.establish.find(
      (op) => op.text === rankingList.establish[1][0]
    );
    const [[count]] = rankingList.establish;
    countEs = count;
  } else {
    for (let i = 0; i < rankingList.establish[0].length; i += 1) {
      if (rankingList.establish[0][i] > 0) {
        es = KODAWARI.establish.find(
          (op) => op.text === rankingList.establish[1][i]
        );
        countEs = rankingList.establish[0][i];
        break;
      }
    }
    if (!es) {
      es = KODAWARI.establish.find(
        (op) => op.text === rankingList.establish[1][0]
      );
      const [[count]] = rankingList.establish;
      countEs = count;
    }
  }
  const initialEstablish = { value: es?.value, text: es?.text, count: countEs };

  return {
    initialRequire,
    initialIncome,
    initialWorkplace,
    initialHoliday,
    initialEmployeeAverageAge,
    initialEmploymentStatus,
    initialWelfareBenefit,
    initialPositions,
    initialLanguage,
    initialEstablish,
  };
};
